module.exports = __webpack_public_path__ + "static/media/option2.75453c48.png";